// extracted by mini-css-extract-plugin
export default {"component":"plZz0","topSide":"H2ZGJ","bottomSide":"J9vyK","vMiddleSide":"VEDpJ","overlay":"jMA3L","content":"jk3GV"};